import { render, staticRenderFns } from "./Way.vue?vue&type=template&id=06d90787&scoped=true"
import script from "./Way.vue?vue&type=script&lang=js"
export * from "./Way.vue?vue&type=script&lang=js"
import style0 from "./Way.vue?vue&type=style&index=0&id=06d90787&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d90787",
  null
  
)

export default component.exports